﻿import React, { useEffect, useState } from "react";
import { IInformationTableTitle } from "./InformationTableTitle";
import { InformationTableTitle } from "./";
import MaterialTable from "material-table";

interface IAboutInformation {
    brandedName: string;
    tool: string;
    toolVersion: string;
    databaseVersion: string;
    deploymentDate: Date;
    toolBranch: string;
}

export const InformationTable: React.FunctionComponent =
    (): React.ReactElement => {
        const [information, setInformation] = useState([]);

        useEffect((): void => {
            void getInfo();
        }, []);
        const getInfo = async (): Promise<void> => {
            const stringResult: string = await $.ajax(`/About/About`, {
                method: `GET`,
            });

            const result: IAboutInformation[] = JSON.parse(stringResult);

            setInformation(result);
        };

        const title: IInformationTableTitle[] = [
            { word: "= Trunk", color: " #E52030" },
            { word: "= Staging", color: "#FFC000" },
            { word: "= Release", color: "#00AE4E" },
            { word: "= Local", color: "#DFEBE9" },
        ];

        return (
            <div className={`scroll-style`}>
                <MaterialTable
                    columns={[
                        {
                            field: `brandedName`,
                            title: `Branded Name`,
                        },
                        {
                            field: `tool`,
                            title: `Tool`,
                        },
                        {
                            title: `Tool Version`,
                            field: `toolVersion`,
                            // TODO: remove this lint disable and fix
                            // eslint-disable-next-line react/display-name
                            render: (rowData): React.ReactElement =>
                                rowData.toolBranch === `Trunk` ? (
                                    <p
                                        style={{
                                            color: `#E52030`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.toolVersion}
                                    </p>
                                ) : rowData.toolBranch === `Staging` ? (
                                    <p
                                        style={{
                                            color: `#FFC000`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.toolVersion}
                                    </p>
                                ) : rowData.toolBranch === `Release` ? (
                                    <p
                                        style={{
                                            color: `#00AE4E`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.toolVersion}
                                    </p>
                                ) : (
                                    <p>{rowData.toolVersion}</p>
                                ),
                            cellStyle: (
                                rowData: IAboutInformation[],
                                cellData: IAboutInformation,
                            ): React.CSSProperties => ({
                                borderLeft:
                                    cellData.databaseVersion !==
                                    cellData.toolVersion
                                        ? "3px solid #E52030"
                                        : "none",
                            }),
                        },
                        {
                            title: `Database Version`,
                            field: `databaseVersion`,
                            // TODO: remove this lint disable and fix
                            // eslint-disable-next-line react/display-name
                            render: (rowData): React.ReactElement =>
                                rowData.toolBranch === `Trunk` ? (
                                    <p
                                        style={{
                                            color: `#E52030`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.databaseVersion}
                                    </p>
                                ) : rowData.toolBranch === `Staging` ? (
                                    <p
                                        style={{
                                            color: `#FFC000`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.databaseVersion}
                                    </p>
                                ) : rowData.toolBranch === `Release` ? (
                                    <p
                                        style={{
                                            color: `g#00AE4E`,
                                            fontWeight: `bold`,
                                        }}
                                    >
                                        {rowData.databaseVersion}
                                    </p>
                                ) : (
                                    <p>{rowData.databaseVersion}</p>
                                ),
                        },
                        {
                            field: `deploymentDate`,
                            title: `Deployment Date`,
                        },
                    ]}
                    data={information}
                    options={{
                        draggable: false,
                        paging: false,
                        minBodyHeight: "45vh",
                        maxBodyHeight: "45vh",
                        overflowY: "initial",
                        headerStyle: { backgroundColor: `#395364` },
                    }}
                    title={<InformationTableTitle legendElements={title} />}
                />
            </div>
        );
    };
